import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_497_2862)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.5 0.5H14.5C14.5 0.5 15.5 0.5 15.5 1.5V14.5C15.5 14.5 15.5 15.5 14.5 15.5H1.5C1.5 15.5 0.5 15.5 0.5 14.5V1.5C0.5 1.5 0.5 0.5 1.5 0.5Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.82533 10.44C6.73833 10.4833 6.64169 10.5038 6.54457 10.4993C6.44745 10.4949 6.35307 10.4657 6.2704 10.4146C6.18773 10.3634 6.11949 10.292 6.07217 10.2071C6.02485 10.1221 6.00001 10.0265 6 9.92933V6.07064C6.00001 5.97342 6.02485 5.87781 6.07217 5.79288C6.11949 5.70796 6.18773 5.63653 6.2704 5.58538C6.35307 5.53422 6.44745 5.50504 6.54457 5.5006C6.64169 5.49615 6.73833 5.51658 6.82533 5.55997L10.6847 7.49C10.7795 7.53726 10.8591 7.61006 10.9149 7.70013C10.9706 7.7902 11.0001 7.89406 11.0001 8C11.0001 8.10586 10.9706 8.20973 10.9149 8.2998C10.8591 8.38986 10.7795 8.46266 10.6847 8.51L6.82533 10.44Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M0.5 3H15.5",
                        stroke: "#6161FF",
                        "stroke-width": "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M0.5 13H15.5",
                        stroke: "#6161FF",
                        "stroke-width": "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_497_2862",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
